import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=5c9a1a74&scoped=true"
import script from "./alerts.vue?vue&type=script&lang=js"
export * from "./alerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a1a74",
  null
  
)

export default component.exports